'use strict'
import moment from 'moment-timezone'

/**
 * Genera un número random basado en la fecha
 * actual el cual varia cada 3 minutos.
 *
 * @returns {string}
 */
export default () => {
    let date    = moment().tz("America/Argentina/Buenos_Aires");
    let range   = 5;
    
    let m = date.month() + 1, d = date.date(), h = date.hour()
    
    let random = date.year().toString() + '.' +
        (m < 10 ? '0'+m.toString() : m.toString()) + '.' +
        (d < 10 ? '0'+d.toString() : d.toString()) + '.' +
        (h < 10 ? '0'+h.toString() : h.toString()) + '.' +
        ((date.minutes() - date.minutes() % range) < 10 ? '0'+(date.minutes() - date.minutes() % range).toString() : (date.minutes() - date.minutes() % range).toString())
    ;
    return random;
};